export enum DateRangeTypes{
    ThisMonth = 0,
    LastMonth = 1,
    YearToDate = 2,
    CustomRange = 3
}

export enum ActivityStatusType{
    Active = 0,
    Deactive = 1
}

export enum RoleName{  
    Admin = 'Admin',
    // BranchManager = 'Branch Manager',
    // SalesPerson = 'Sales Person',
    // SalePerson = 'Sale Person',
    // Manager = 'Manager',
    // TableHost = 'Table Host',
    // Custom = 'Custom',
    // Buyer = 'Buyer',
}

export enum DepositInto
{
    Bank_OD_AC= 'Bank OD A/C',
    Cash_in_Hand= 'Cash-in Hand',
    Bank_Account= 'Bank Account'
}

export enum ColumnCellType
{
    DefaultColumn = "DefaultColumn",
    WtColumn = "WtColumn",
    AmountColumn = "AmountColumn",
    ClosingWtColumn = "ClosingWtColumn",
    OpeningWtColumn = "OpeningWtColumn",
    ClosingAmountColumn = "ClosingAmountColumn",
    OpeningAmountColumn = "OpeningAmountColumn",
}

export enum StorageName {
    //#region GRIDNAME
  ADMINISTRATION_ACTIVITY_LOG_GRID = "ADMINISTRATION_ACTIVITY_LOG_GRID",
  //#endregion GRIDNAME


  //#region DROPDOWN
  PLAN_DROPDOWN ="PLAN_DROPDOWN",
  PLAN_TYPE_DROPDOWN ="PLAN_TYPE_DROPDOWN",
  ACCOUNT_DROPDOWN = "ACCOUNT_DROPDOWN",
  STATE_DROPDOWN ="STATE_DROPDOWN",
  CITY_DROPDOWN ="CITY_DROPDOWN",
  EXPIRED_MONTH_DROPDOWN ="EXPIRED_MONTH_DROPDOWN",
  COUNTRY_DROPDOWN ="COUNTRY_DROPDOWN",
  STATUS_DROPDOWN ="STATUS_DROPDOWN",
  USER_DROPDOWN ="USER_DROPDOWN",
  DATE_RANGE_DROPDOWN = "DATE_RANGE_DROPDOWN",
  ACCOUNT_LEDGER_DROPDOWN= "ACCOUNT_LEDGER_DROPDOWN",
  PAYMENT_TYPE_DROPDOWN = "PAYMENT_TYPE_DROPDOWN",
  TRANSFER_FROM_DROPDOWN = "TRANSFER_FROM_DROPDOWN",
  AGAINST_DROPDOWN = "AGAINST_DROPDOWN",
  DEPOSIT_INTO_DROPDOWN = "DEPOSIT_INTO_DROPDOWN",
  SUBSCRIPTION_STATUS_DROPDOWN = "SUBSCRIPTION_STATUS_DROPDOWN",
  SALSEPERSON_DROPDOWN="SALSEPERSON_DROPDOWN",
  MARKETING_CATEGORY_DROPDOWN="MARKETING_CATEGORY_DROPDOWN",
  INSTALL_FROM_DROPDOWN="INSTALL_FROM_DROPDOWN",
  NOTIFICATION_TYPE_DROPDOWN ="NOTIFICATION_TYPE_DROPDOWN",
  NOTIFICATION_LANGUAGE_DROPDOWN ="NOTIFICATION_LANGUAGE_DROPDOWN",
  ISSUE_RESOLVED_DROPDOWN ="ISSUE_RESOLVED_DROPDOWN",
  INSTALLATION_CHECKLIST_STATUS_DROPDOWN ="INSTALLATION_CHECKLIST_STATUS_DROPDOWN",
  INSTALLATION_CHECKLIST_ITEM_TYPE_DROPDOWN ="INSTALLATION_CHECKLIST_ITEM_TYPE_DROPDOWN",
  TRAINING_STATUS_DROPDOWN ="TRAINING_STATUS_DROPDOWN",
  PLAN_MASTER_DROPDOWN ="PLAN_MASTER_DROPDOWN",
  SOFTWARE_PLAN_DROPDOWN ="SOFTWARE_PLAN_DROPDOWN",
//   ADMIN_SEND_WHATSAPP_USER_DROPDOWN = "ADMIN_SEND_WHATSAPP_USER_DROPDOWN",
//   ADMIN_SEND_WHATSAPP_USER_PHONE_DROPDOWN = "ADMIN_SEND_WHATSAPP_USER_PHONE_DROPDOWN",
//   ADMIN_SEND_WHATSAPP_USER_SHOP_NAME_DROPDOWN = "ADMIN_SEND_WHATSAPP_USER_SHOP_NAME_DROPDOWN",
  CONATACT_LIST_DROPDOWN = "CONATACT_LIST_DROPDOWN",

  //#endregion DROPDOWN
 AGAINST_ID = "AGAINST_ID"
}

export enum PaymentMethod
{
    Cash = 10,
    Bank = 20,
    Cheque = 30,
    UPI = 40,
    Card = 50,
    // M2A = 60,
    // A2M = 70,
    // MetalExchange = 80,
    // OldJewellery = 90
}
export enum RoutePath{
    WhatsappCampaign = '/whatsapp-campaign',
    WhatsappReport = '/whatsapp-report',
    Inbox ='/inbox'
}

export enum AppPasswords{
    passForUpdateBillDetailsInSubscription = "SWapp.COM"
}

export enum NavigateToCustomerDetails{
    UserRegistration = 1,
    MinizUserRegistration = 2,
}

// ----Ag-grid Cell Width Enum -----

export enum CheckboxColWidth{
    minWidth= 50,
    maxWidth= 50,
}
export enum NameColWidth{
    minWidth=250,
    maxWidth=300,
}
export enum BillNoColWidth{
    minWidth=190,
    maxWidth=220,
}
export enum ContactColWidth{
    minWidth=150,
    maxWidth=200,
}
export enum StatusColWidth{
    minWidth=100,
    maxWidth=130,
}
export enum DateColWidth{
    minWidth=150,
    maxWidth=180,
}
export enum AmountColWidth{
    minWidth=100,
    maxWidth=150,
}
export enum ActionColWidth{
    minWidth=60,
    maxWidth=60,
}
export enum VoucherTypeColWidth{
    minWidth=150,
    maxWidth=200,
}
export enum TransferColWidth{
    minWidth = 170,
    maxWidth = 200,
}
export enum AgainstColWidth{
    minWidth=180,
    maxWidth=230,
}
export enum CommentColWidth{
    minWidth=150,
    maxWidth=180,
}
export enum TransactionColWidth{
    minWidth=140,
    maxWidth=180,
}
export enum ImageColWidth{
    minWidth=35,
    maxWidth=35,
}
export enum InfoDataColWidth{
    minWidth=150,
    maxWidth=200,
}
export enum CategoryColWidth{
    minWidth=200,
    maxWidth=250,
}
